import { withFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getActiveClients } from '../../../Actions/UserAction'
import Button from '../../../Components/Button'
import Field from '../../../Components/Formik/Field'
import Form from '../../../Components/Formik/Form'
import { getOrderNames, ORDER_INVOICE_STATUS_OPTIONS } from '../../../Util/Options'

function InvoiceFilter({ values, setValues, filterData }) {
  const [clients, setClients] = useState([])
  const { type } = useParams()
  const { clientName } = getOrderNames(type)

  const getData = () => {
    getActiveClients().then((clients) => {
      if (clients) {
        const clientOptions = []
        clients.forEach((val) => {
          if (val.type === clientName || val.type === 'Both') {
            clientOptions.push({ label: val.name, value: val._id })
          }
        })
        setClients(clientOptions)
      }
    })
  }

  useEffect(() => {
    setValues({ ...values, ...filterData })
    getData()
  }, [type])

  return (
    <Form>
      <div className="form-fields">
        <Field name="invoiceNo" label="Doc No" />
      </div>
      <div className="form-fields">
        <Field as="date-range" name="issueDate" label="Issue Date" />
      </div>
      <div className="form-fields">
        <Field as="date-range" name="taxDate" label="Tax Date" />
      </div>
      <div className="form-fields">
        <Field as="date-range" name="paymentDate" label="Payment Date" />
      </div>
      <div className="form-fields">
        <Field
          as="select"
          name="status"
          label="Status"
          options={[{ label: 'All', value: '' }, ...ORDER_INVOICE_STATUS_OPTIONS]}
        />
      </div>
      <div className="form-fields">
        <Field
          as="select"
          name="client"
          label={clientName}
          options={[{ label: 'All', value: '' }, ...clients]}
        />
      </div>
      <div className="form-fields">
        <Button type="submit" variant="secondary" className="search">
          <i className="flaticon-search-interface-symbol" />
          Search
        </Button>
        <Button type="reset" className="btn-block btn-glow search">
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default withFormik({
  mapPropsToValues: () => ({
    invoiceNo: '',
    issueDate: '',
    taxDate: '',
    paymentDate: '',
    status: '',
    client: ''
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values)
})(InvoiceFilter)
